// The one corner radius for every card in the app, wherever it is drawn:
// DOM tiles and previews, the in-hand cards, the 3D table mesh, the foil
// shaders. Expressed as a fraction of the card's SHORT side so it scales
// with the card, not with the UI (a card is a physical object, not a panel;
// the --radius-* ramp is for chrome).
//
// Why 9%: the card art ships with rounded transparent corners baked in, and
// the radius differs by finish (standard scans ~7.6% of the width, foil scans
// ~8.5%). Any clip smaller than the art's own corner lets the scan's corner
// show through, so foils and regulars would round differently. 9% sits
// above both, so the app's clip defines every card's silhouette.
//
// CSS mirrors this as --radius-card / --radius-card-landscape in
// src/index.css; src/lib/cardCorner.test.js keeps the two in sync.
export const CARD_CORNER_RATIO = 0.09;

// Sorcery card face, 63.5 x 88.9 mm.
export const CARD_ASPECT = 63.5 / 88.9;

const pct = (n) => `${parseFloat((n * 100).toFixed(3))}%`;

// `border-radius` pairs (horizontal / vertical) that yield a circular corner
// of CARD_CORNER_RATIO on any element with the card's aspect ratio.
export const CARD_CORNER_CSS = `${pct(CARD_CORNER_RATIO)} / ${pct(CARD_CORNER_RATIO * CARD_ASPECT)}`;
export const CARD_CORNER_LANDSCAPE_CSS = `${pct(CARD_CORNER_RATIO * CARD_ASPECT)} / ${pct(CARD_CORNER_RATIO)}`;
